export const SHARED_WITH_YOU_CONSTANTS = {
  TITLE: 'Shared with you',
  SEE_ALL: 'See all shared \u2192',
  EMPTY: 'No stories shared with you yet',
  ERROR: 'Unable to load shared stories',
  LOADING: 'Loading...',
  BUCKET_NEW: 'New',
  BUCKET_THIS_WEEK: 'This Week',
  BUCKET_LAST_WEEK: 'Last Week',
  BUCKET_OLDER: 'Older',
  LOAD_MORE: 'Load more',
  TAB_SHARED_WITH_YOU: 'Shared with you',
  TAB_SHARED_BY_YOU: 'Shared by you',
  EMPTY_SHARED_BY_YOU: "You haven't shared any stories yet.",
};
